export default "__VITE_ASSET__BjmzPbm3__"